import { useNavigate } from 'react-router-dom';
import { apiClient } from '../api/client';
import { useAuthStore } from '../store/authStore';
import { analytics } from './useAnalytics';

export function useSignOut() {
  const logout   = useAuthStore((s) => s.logout);
  const navigate = useNavigate();

  return async function signOut() {
    try {
      await apiClient.post('/auth/logout', {
        refresh_token: useAuthStore.getState().refreshToken,
      });
    } catch {}
    analytics.trackUserLoggedOut();
    // P3.3: clear user properties so subsequent events aren't attributed
    analytics.setUserId(null);
    logout();
    navigate('/login');
  };
}
